import { createContext, useContext } from "react";

export const GridContext = createContext({});
export const useGridContext = () => useContext(GridContext);
export const useTableName = () => useGridContext().tableName;
